import React, { 
  useState,
  useRef,
  useEffect,
} from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import ProfileTab from '../../Components/TabsProfile/ProfileTab'
import AddressTab from '../../Components/TabsProfile/AddressTab'
import MiscInfo from '../../Components/TabsProfile/MiscInfoTab'
import Dependents from '../../Components/TabsProfile/DependentsTab'
import Locker from '../../Components/TabsProfile/LockerTab'
import Sticker from '../../Components/TabsProfile/StickerTab'
import OtherBilling from '../../Components/TabsProfile/OtherBillingTab'
import OtherDues from '../../Components/TabsProfile/OtherDuesTab'
import url from '../../Assets/user-profile-icon-free-vector.jpg'
import '../../CssFiles/MemberProfile.css';
import {Divider,} from 'antd';
import { RotateLoader } from 'react-spinners';

import { 
  Layout,
  Col, 
  Row,
  Space,
  Card, 
  Image,
  Tabs,
  Modal,
  QRCode,
  Button,
  Tag,
  Dropdown,
  Form,
  Input,
  Select,
} from 'antd';
import { 
  DownOutlined,
  EditOutlined, 
  QrcodeOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import { 
  capitalizeEachWord,
  formatDate, 
} from '../../Utils/Common';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { useNavigate, useLocation } from "react-router-dom"
import html2canvas from 'html2canvas';
import { usePostRequest } from '../../hooks/usePostRequest';
import { StatusOptions } from '../../Utils/api/DropdownfilterApi';

const { TabPane } = Tabs;
const { Meta } = Card;

const MemberProfile = () => {
  const navigate = useNavigate() 
  const location = useLocation();
  const { id } = location.state || {};
  const [visibleQr, setVisibleQr] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [memberDetails, setMemberDetails] = useState([])
  const [image, setImage] = useState([])
  const qrRef = useRef();
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [statusForm] = Form.useForm();
  const { callPost: saveStatus, loading: savingStatus } = usePostRequest(() => {
    setStatusModalOpen(false);
    statusForm.resetFields();
    fetchMembersData();
  });
  const statusOptions = StatusOptions()
  .filter((option) => option.value)
  .map((option) => ({
    ...option,
    disabled: option.value === memberDetails?.latest_status,
  }));

  const handleSaveStatus = async () => {
    if (savingStatus || !memberDetails?.id) return;
    try {
      const values = await statusForm.validateFields();
      await saveStatus('members/update_status', {
        member_id: memberDetails.id,
        old_status: memberDetails.latest_status || '',
        new_status: values.new_status,
      });
    } catch {
      // Form validation displays errors beside the fields.
    }
  };

  const handleDownload = async () => {
    const canvas = await html2canvas(qrRef.current);
    const link = document.createElement('a');
    link.href = canvas.toDataURL('image/png');
    link.download = `${memberDetails.full_name}.png`;
    link.click();
  };

  function StatusTag(status) {
    if (status === "Active" || status === "Transferred" || status === "Assigned") {
      return (
        <Tag
          color='#02A556'
          className='header-status member-profile-status' 

        >
          {status?.toUpperCase()}
        </Tag>
      );
    } else if (status === "Pending") {
      return (
        <Tag
          color='#FFA500'
          className='header-status member-profile-status' 
        >
          {status?.toUpperCase()}
        </Tag>
      );
    } else {
      return (
        <Tag 
          color='#fe2e2e'
          className='header-status member-profile-status' 
        >
          {status?.toUpperCase()}
        </Tag>
      );
    }
  }
  
  async function fetchMembersData() {
    setIsLoading(true)
    const response = await UseGetRequest("members/get_all", {member_id: id});
    if (response?.data) {
      const member_data = response?.data?.members?.map((data) => ({
        ...data,
        full_name: capitalizeEachWord(data.last_name) + " " + capitalizeEachWord(data.first_name) + " " + capitalizeEachWord(data.middle_name) + " " + capitalizeEachWord(data.suffix)
      }))
      setMemberDetails(member_data[0])
      setImage(member_data[0].profile_pic_url)
    } else {
      setMemberDetails([])
    }    
    setIsLoading(false)
  }

  useEffect(() => {
    fetchMembersData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const memberActions = {
    items: [
      { key: 'edit', label: 'Edit', icon: <EditOutlined /> },
      { key: 'status', label: 'Change Status', icon: <SwapOutlined /> },
      { key: 'qr', label: 'QR code', icon: <QrcodeOutlined /> },
    ],
    onClick: ({ key }) => {
      if (key === 'edit') {
        navigate('/member/edit/' + id);
      } else if (key === 'status') {
        statusForm.resetFields();
        setStatusModalOpen(true);
      } else if (key === 'qr') {
        setVisibleQr(true);
      }
    },
  };

  return (
    <Layout className='page'>
      <Navbar navKey={'member'}/>
        {
          isLoading ? (
            <Layout className='content-container overflow-y center'>
              <RotateLoader color="#005E30" size={20} />
            </Layout>
          ) : (
            <Layout className='content-container overflow-y'>
              <Row className='custom-padding responsive-tab-inline'>
                <Col span={24}>
                  <Row className='mb-4'>
                    <Col 
                      xs={24} sm={24} md={17} lg={17} xl={17}
                      onClick={() => navigate('/member')}
                      className='cursor'
                    >
                      <span
                        className='header-container' 
                      >
                        MEMBERS PROFILE
                      </span>
                    </Col>
                    <Col
                      xs={24} sm={24} md={7} lg={7} xl={7}
                      className='member-profile-actions'
                    >
                      <Dropdown menu={memberActions} trigger={['click']} placement='bottomRight'>
                        <Button type='primary' className='member-profile-action-button'>
                          Select Action <DownOutlined />
                        </Button>
                      </Dropdown>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={24} sm={24} md={7} lg={5} xl={5}
                      align='center'
                    >
                      <Space direction="vertical">
                        <Card
                            cover={
                                <Image
                                    alt="image"
                                    src={image ? image : url}
                                    className='profile-img'
                                />
                            }
                            className="square-image"
                        >
                            <Meta
                                // avatar={<Avatar src={image ? image : url} />}
                                className='avatar-container'
                                // title={<span className="custom-title">{capitalizeEachWord(patientDetails.full_name)}</span>}                
                                // description={patientDetails.age ? patientDetails.gender ? patientDetails.age + "/" + patientDetails.gender : patientDetails.age : ""}
                                title={
                                  <>
                                    <div className='member-profile-status-container'>
                                      {StatusTag(memberDetails?.latest_status)}
                                    </div>
                                    <div>
                                      {capitalizeEachWord(memberDetails.last_name)}, {' '}
                                      {capitalizeEachWord(memberDetails.first_name)}{' '}
                                      {memberDetails?.suffix
                                        ? capitalizeEachWord(memberDetails.suffix)
                                        : ''}
                                    </div>
                                  </>
                                }
                            />
                            <Divider className="member-profile-divider" />
                            <div 
                                className='mt-2 member-profile-details'
                            > 
                              <p>Member ID: {memberDetails?.member_no}</p>
      
                              <p>Last Name: {memberDetails?.last_name}</p>
      
                              <p>First Name: {memberDetails?.first_name +' '+ memberDetails?.suffix}</p>
      
                              <p>Middle Name: {memberDetails?.middle_name}</p>
      
                              {/* <p>Status: {memberDetails?.latest_status}</p> */}
                        
                              <p>Birthdate: {formatDate(memberDetails?.birthdate)}</p>
      
                              <p>Age: {memberDetails?.age}</p>
                        
                              <p>Gender: {capitalizeEachWord(memberDetails?.gender)}</p>
      
                              <p>Nickname: {capitalizeEachWord(memberDetails?.nickname)}</p>
                      
                              <p>Civil Status: {capitalizeEachWord(memberDetails?.civil_status)}</p>
                        
                              <p>Nationality: {memberDetails?.nationality}</p>
                        
                              <p>Type: {memberDetails?.type}</p>
                        
                              <p>Class: {memberDetails?.class}</p>
                        
                              <p>Seller's Code: {memberDetails?.sellers_code}</p>
                          
                              <p>Customer ID: {memberDetails?.ar_cust_id}</p> 
                            </div>
                        </Card>
                      </Space>
                    </Col>
                    <Col 
                      xs={12} sm={12} md={17} lg={19} xl={19}
                      className='resp-top'
                    >
                      <Tabs
                        // activeKey={selectedTab}
                        id="PO-tabs"
                        className="profile-tabs"
                        type="card"
                        animated="true"
                        size="medium"
                        // onChange={(e) => {
                        //   setSelectedTab(e)
                        // }}
                      >
                        <TabPane key="profile" tab="Profile">
                          <ProfileTab
                            memberData={memberDetails}
                          />
                        </TabPane>
      
                        <TabPane key="address" tab="Address">
                          <AddressTab
                            addressData={memberDetails?.address}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                          />
                        </TabPane>
                        
                        <TabPane key="mis_info" tab="Misc Info">
                          <MiscInfo
                            miscData={memberDetails?.misc_info}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                          />
                        </TabPane>
                        
                        <TabPane key="dependents" tab="Dependents">
                          <Dependents
                            dependentsData={memberDetails?.dependents}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                          />
                        </TabPane>
                        
                        <TabPane key="locker" tab="Locker">
                          <Locker
                            lockersData={memberDetails?.lockers}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                          />
                        </TabPane>
      
                        <TabPane key="sticker" tab="Sticker">
                          <Sticker
                            stickersData={memberDetails?.stickers}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                          />
                        </TabPane>
      
                        <TabPane key="other_billing" tab="Other Billing">
                          <OtherBilling
                            memberDetails={memberDetails}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                          />
                        </TabPane>
      
                        <TabPane key="other_dues" tab="Dues / Others">
                          <OtherDues
                            duesData={memberDetails?.dues_others}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                          />
                        </TabPane>
                      </Tabs>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Modal
                title="Change Status"
                open={statusModalOpen}
                onOk={handleSaveStatus}
                onCancel={() => { if (!savingStatus) setStatusModalOpen(false); }}
                okText="Save"
                confirmLoading={savingStatus}
                cancelButtonProps={{ disabled: savingStatus }}
                closable={!savingStatus}
                maskClosable={!savingStatus}
              >
                <Form form={statusForm} layout="vertical" disabled={savingStatus}>
                  <Form.Item label="Member">
                    <Input value={memberDetails.full_name || ''} disabled />
                  </Form.Item>
                  <Row gutter={8}>
                    <Col span={12}>
                      <Form.Item label="Old Status">
                        <Input value={memberDetails.latest_status || ''} disabled />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="New Status"
                        name="new_status"
                        rules={[{ required: true, message: 'Please select a new status.' }]}
                      >
                        <Select placeholder="Select Status" options={statusOptions} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Modal>
              <Modal
                title="QR Code"
                open={visibleQr}
                // onOk={onClose}
                onCancel={() => setVisibleQr(false)}
                footer={null}
              >
                <Row>
                  <Col span={24} align='center' ref={qrRef}>
                    <QRCode value={"$2a$12$YxbwjC3HdEHFsh6L4po1eYXgO6Kxs8r5.q9PmZiYH8F5ndAC.drG/" + id} size={256}/>
                    <span className='qr-name'>{memberDetails?.last_name}, {memberDetails?.first_name}</span>
                  </Col>
                </Row>
                <Row>
                  <Col span={24} align='center'>
                    <Button type="primary" onClick={handleDownload} style={{ marginTop: 20 }}>
                      Download QR Code
                    </Button>
                  </Col>
                </Row>
              </Modal>
            </Layout>
          )
        }
    </Layout>
  )
}

export default MemberProfile
